import apiClient from './client'
import type { CaseRecord, GuidanceResponse } from '../types'

export const caseApi = {
  create: async (data: any): Promise<{ id: number; message: string }> => {
    return apiClient.post('/cases', data)
  },

  getList: async (skip = 0, limit = 100): Promise<CaseRecord[]> => {
    return apiClient.get('/cases', { params: { skip, limit } })
  },

  getById: async (id: number): Promise<CaseRecord> => {
    return apiClient.get(`/cases/${id}`)
  },

  update: async (id: number, data: any): Promise<CaseRecord> => {
    return apiClient.put(`/cases/${id}`, data)
  },

  delete: async (id: number): Promise<void> => {
    return apiClient.delete(`/cases/${id}`)
  },

  getGuidance: async (caseId: number): Promise<GuidanceResponse> => {
    return apiClient.post(`/cases/${caseId}/guide`)
  },
}

export default caseApi
